export class ActivityDetailModel {
  id?: number
  module: any
  description: string
  type: any
  creationTime: any
  customerId?: any

  constructor() {
    this.id = undefined
    this.module = undefined
    this.description = ""
    this.type = undefined
    this.creationTime = undefined
    this.description = ""
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new ActivityDetailModel(), obj)
    newObj.relatedPersons = obj.relatedPersons.map((p) => ({
      value: p.id,
      label: p.displayName,
    }))
    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
